/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable max-len */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { Component } from 'react'
import { observer } from 'mobx-react'
import { observable, makeObservable } from 'mobx'
import AnimateHeight from 'react-animate-height'
import i18n from 'i18next'
import * as R from 'ramda'

import Select from '../components/form/Select'
import './Question.scss'
import GrabIcon from '../assets/images/move-icon.svg'
import blockTypes from '../QList/blockTypes'
import QuestionPreview from '../components/QuestionPreview/QuestionPreview'
import { getQuestionTitle } from '../utils/QuestionHelper'
import Menu from '../UniformComponents/Menu'
import Checkbox from '../components/form/Checkbox'
import Tooltip from '../UniformComponents/Tooltip'
import HoverInfo from '../UniformComponents/HoverInfo'
import Typography from '../UniformComponents/Typography'
import Button from '../UniformComponents/Button'

import DeleteQuestion from './Modals/DeleteQuestion'
import { questionTypeCanInherit } from '../utils/helpers'

// Used in /mandatoryquestions
@observer
export default class Question extends Component {
    @observable dashboardToggleStatus = false

    @observable dashboardSelectedBlock = null

    @observable additionalQuestionStatus = false

    @observable questionTypeCode = ''

    @observable showInherit = false

    constructor(props) {
        super(props)
        makeObservable(this)
        this.state = {
            isExpanded: false,
            isCtxMenuShown: false,
            showDeleteModal: false,
        }
        this.body = {
            questionId: this.props.question.questionId,
            respondentType: this.props.store.respondentType.value,
            productType: this.props.store.eventType.value,
            scope: this.getScope(),
            recordId: this.props.store.rid,
        }
        this.questionTypeCode = ''
        this.hasNumericCodes = false
        this.additionalQuestionId = ''
    }

    isUserAllowed = (userRole) => {
        const allowedUserRoles = ['MASTER', 'PORTFOLIO', 'SUPER']
        return R.includes(userRole, allowedUserRoles)
    }

    closeDeleteModal = () => this.setState({ showDeleteModal: false })

    toggleCtxMenu = () => {
        this.setState((prevState) => ({ isCtxMenuShown: !prevState.isCtxMenuShown }))
    }

    componentDidMount = async () => {
        const { question: { questionId }, appStore } = this.props

        if (this.props.question.additionalQuestion) {
            const { chartType } = this.props.question.additionalQuestion
            this.dashboardSelectedBlock = blockTypes[chartType]
            this.additionalQuestionStatus = true
        }

        if (window.location.pathname.includes('qlist')) {
            try {
                const res = await appStore.http.get(`/api/question/${questionId}/3`)
                const hasOptionSet = R.has('optionSet')
                this.questionTypeCode = res.question.questionTypeCode
                if (hasOptionSet(res.question)) {
                    this.hasNumericCodes = res.question.optionSet.hasNumericCodes
                }
            } catch (e) {
                const { addNotification } = this.props.appStore
                addNotification(null, 'There was an error obtaining additional question data. Please reload the page.', 'error')
            }
        }
    }

    componentWillUnmount = () => {
        document.removeEventListener('click', this.checkIfClickedOutside)
    }

     checkAddToQuadrant = (question) => {
         if (['NF', 'I', 'PC', 'OD'].includes(question.questionType)) {
             return true
         }
         if (['RD', 'TB', 'SB'].includes(question.questionType)) {
             return question.hasNumericCodes
         }
     }

    canInherit = () => {
        const {
            question,
            allowInherit,
            questionIndex,
        } = this.props
        const { isEditable, questionType } = question
        return (
            allowInherit
            && isEditable
            && questionIndex > 0
            && questionTypeCanInherit(questionType)
        )
    }

    checkVisibility = (key, question) => {
        switch (key) {
            case 'edit':
                return question.isEditable && question.modifiable && question.deletable

            case 'mandatory':
                return true

            case 'recommended':
                return true

            case 'importdata':
                return question.questionType === 'TX'

            case 'quadrant':
                return this.checkAddToQuadrant(question)

            case 'inherit':
                return this.canInherit()

            case 'delete':
                return question.modifiable
            case 'ai': {
                const { appStore, store: { oid, rid } } = this.props
                const isExploriAdmin = appStore.isExploriAdmin()
                const isQuestionTypeAllowed = ['TA', 'TX'].includes(question.questionType) && !question.viewOnly
                const isExploriClientQlist = rid === 1 && oid === 3
                return isQuestionTypeAllowed && isExploriClientQlist && isExploriAdmin
            }
            case 'disableAiCoding': {
                const { appStore } = this.props
                return ['TA', 'TX'].includes(question.questionType)
                    && !question.viewOnly
                    && R.pathOr(false, ['userData', 'flags', 'isAiSummaryEnabled'], appStore)
            }
            default:
                return false
        }
    }

    executeAction = async (func) => {
        this.setState({ isCtxMenuShown: false })
        await func()
    }

    setShowDeleteModal = () => {
        this.setState({ showDeleteModal: true })
    }

    renderLeftIcons = () => {
        const { question } = this.props
        return (
            <span className="options">
                {!question.modifiable && <i className="fa-light fa-lock"><Tooltip text={i18n.t('questionLibrary.editPanel.nonModifiable')} direction="bottom" /></i>}
                {question.isAI === 1 && <i className="fa-light fa-sparkles"><Tooltip text={i18n.t('qlist.isAI.title.active')} direction="bottom" /></i>}
            </span>
        )
    }

    renderRightIcons = () => {
        const { question } = this.props
        return (
            <span className="options">
                {question.isRecommended && <i className="fa-light fa-thumbs-up"><Tooltip text={i18n.t('questionLibrary.question.option.tooltip.recommended')} direction="bottom" /></i>}
                {/* {question.allowQuadrantAnalysis && <i className="fa-light fa-chart-scatter"><Tooltip text={i18n.t('questionLibrary.question.option.tooltip.addToQuadrant')} direction="bottom" /></i>} */}
                {question.parentId && <i className="fa-light fa-diagram-project"><Tooltip text={i18n.t('s_alt_q_contains_inherited')} direction="bottom" /></i>}
                {question.isDataImport && <i className="fa-light fa-folder-arrow-up"><Tooltip text={i18n.t('questionLibrary.question.option.tooltip.importedData')} direction="bottom" /></i>}
                {question.isMandatory && (
                    <div className="icon-tooltip">
                        <Tooltip
                            text={i18n.t('questionLibrary.question.option.tooltip.makeRequired')}
                            direction="up"
                            style={{ width: 200 }}
                        />
                        <Typography type="p" color="grey">{i18n.t('s_required')}</Typography>
                    </div>
                )}
            </span>
        )
    }

    getScope = () => {
        const { oid } = this.props.store
        return (oid === 5) ? 'portfolio' : 'company'
    }

    submitAdditionalQuestion = async (chartType) => {
        const { additionalQuestion, questionId } = this.props.question
        const { additionalQuestionsUrl, appStore, appStore: { qlistToken } } = this.props
        const body = JSON.stringify({
            chartType,
            ...(additionalQuestion && { id: additionalQuestion.id }),
            ...this.body,
        })
        const method = (additionalQuestion) ? 'put' : 'post'

        return appStore.http[method](additionalQuestionsUrl, body, qlistToken)
            .then((res) => {
                if (!additionalQuestion) {
                    this.additionalQuestionId = res.id
                }
                this.additionalQuestionStatus = true
                return {
                    message: 'Question successfully added to the dashboard',
                    status: 'success',
                }
            })
            .catch((err) => ({
                message: `There was an error adding question ${questionId} to the dashboard`,
                status: 'error',
                err,
            }))
    }

    deleteAdditionalQuestion = async () => {
        const {
            appStore,
            appStore: {
                qlistToken,
            },
            additionalQuestionsUrl,
            question: {
                additionalQuestion,
                questionId,
            },
        } = this.props
        const additionalQuestionId = (additionalQuestion) ? additionalQuestion.id : this.additionalQuestionId

        return appStore.http.delete(`${additionalQuestionsUrl}/${additionalQuestionId}`, qlistToken)
            .then(() => {
                this.additionalQuestionStatus = false
                return {
                    message: 'Question successfully removed from the dashboard',
                    status: 'success',
                }
            })
            .catch((err) => ({
                message: `There was an error removing question ${questionId} from the dashboard`,
                status: 'error',
                err,
            }))
    }

    makeRequest = async (selected, action) => {
        switch (action) {
            case 'select-option':
                return this.submitAdditionalQuestion(selected.value)
            case 'clear':
                return this.deleteAdditionalQuestion()
            default:
                return {
                    err: 'invalid action',
                }
        }
    }

    toggleIsExpanded = async () => {
        const { store, question } = this.props
        const { questionId } = question
        const { isExpanded } = this.state

        if (isExpanded) {
            this.setState({ isExpanded: false })
            return
        }
        if (this.questionFull) {
            this.setState({ isExpanded: true })
            return
        }
        try {
            const questionRes = await store.getQuestionDetails(questionId)
            this.questionFull = questionRes.question

            if (this.questionFull.questionTypeCode === 'SG') {
                this.questionFull.optionSetX = this.questionFull.optionSetX || { options: [] }
                this.questionFull.optionSetY = this.questionFull.optionSetY || { options: [] }
            }
            if (this.questionFull.questionTypeCode === 'NF' || this.questionFull.questionTypeCode === 'FM') {
                this.questionFull.optionSet = this.questionFull.optionSet.map((o) => ({ ...o, question: { ...o.question, validator: { error: [], otherValidation: { validator: { error: [] } } } } }))
            }
            this.setState((prevState) => ({ ...prevState, isExpanded: !prevState.isExpanded }))
        } catch (e) {
            this.setState({ isExpanded: false })
        }
    }

    previewLink = () => {
        const { question, appStore } = this.props
        const { useLatestUI } = appStore
        const prot = window.location.protocol
        let url = window.location.host.split('.')
        if (url[0].match(/dev/)) {
            url[0] = `surveys.${url[0]}`
        } else {
            url[0] = 'surveys'
        }
        url = url.join('.')
        console.log(`getPreviewLink ${appStore}`)
        return `${prot}//${url}/?${useLatestUI ? '&version=v2' : ''}&questionOnly=true&questionId=${question.questionId}${(appStore.surveyLocale ? `&langcode=${appStore.surveyLocale}` : '')}`
    }

    getTitleByLocale = (question) => {
        const { appStore } = this.props
        const { surveyLocale } = appStore
        const { initialLocale } = question
        const { defaultLocale } = appStore.survey.metadata
        const titleObj = question.locales

        return R.pathOr(question.title, ['text'], getQuestionTitle({
            content: titleObj, locale: surveyLocale, defaultLocale, initialLocale,
        }))
    }

    changeParentId = (obj) => {
        const { question } = this.props
        question.setParentId(R.pathOr(null, ['value'], obj))
    }

    hasChildQuestion = () => {
        const { store, question } = this.props
        const childQuestion = store.findChildQuestion(question.questionId)

        return !R.isNil(childQuestion)
    }

    getDeleteToolTip = () => {
        const { store, question } = this.props
        const childQuestion = store.findChildQuestion(question.questionId)

        return childQuestion
            ? i18n.t('qlist_inherited_option_in_child', { child: childQuestion.title })
            : null
    }

    createCtxMenu = () => {
        const { question, store } = this.props
        const { getParentOption, getPossibleParentQuestions } = store
        const hasParentOption = !!getParentOption(question.parentId)
        const hasChild = this.hasChildQuestion()

        const optionMenuList = (
            [
                {
                    compName: 'editQuestion',
                    icon: 'fa-light fa-pen-to-square',
                    label: i18n.t('edit_question'),
                    menuShow: this.checkVisibility('edit', question),
                    onClick: () => this.executeAction(question.toggleEditable),
                },
                {
                    compName: 'makeAI',
                    icon: 'fa-solid fa-sparkles',
                    label: i18n.t('qlist.setAsAI'),
                    menuShow: this.checkVisibility('ai', question),
                    value: question.isAI,
                    menuType: 'checkbox',
                    onClick: () => this.executeAction(question.toggleIsAI),
                },
                {
                    compName: 'mapAI',
                    icon: 'fa-solid fa-microchip',
                    label: i18n.t('qlist.createAIMapping'),
                    menuShow: this.checkVisibility('ai', question) && question.isAI,
                    onClick: () => this.executeAction(() => store.toggleQuestionPiping(question)),
                },
                {
                    compName: 'makeMandatory',
                    icon: 'fa-light fa-circle-star',
                    label: i18n.t('questionLibrary.question.option.required'),
                    menuShow: this.checkVisibility('mandatory', question),
                    menuType: 'checkbox',
                    value: question.isMandatory,
                    onClick: () => this.executeAction(question.toggleMandatory),
                    menuTooltip: i18n.t('questionLibrary.question.option.infoText.required'),
                },
                {
                    compName: 'recommended',
                    icon: 'fa-light fa-thumbs-up',
                    label: i18n.t('questionLibrary.question.option.recommended'),
                    menuShow: this.checkVisibility('recommended', question),
                    menuType: 'checkbox',
                    value: question.isRecommended,
                    onClick: () => this.executeAction(question.toggleRecommended),
                    menuTooltip: i18n.t('questionLibrary.question.option.infoText.recommended'),
                },
                {
                    compName: 'isAiCodingDisabled',
                    icon: 'fal fa-sparkles',
                    label: i18n.t('questionLibrary.question.option.isAiCodingDisabled'),
                    menuShow: this.checkVisibility('disableAiCoding', question),
                    menuType: 'checkbox',
                    value: question.isAiCodingDisabled,
                    onClick: () => this.executeAction(question.toggleIsAiCodingDisabled),
                    menuTooltip: i18n.t('questionLibrary.question.option.infoText.isAiCodingDisabled'),
                },
                {
                    compName: 'importdata',
                    icon: 'fa-light fa-folder-arrow-up',
                    label: i18n.t('questionLibrary.question.option.importedData'),
                    menuShow: this.checkVisibility('importdata', question),
                    menuType: 'checkbox',
                    value: question.isDataImport,
                    onClick: () => this.executeAction(question.toggleIsDataImport),
                    menuTooltip: i18n.t('questionLibrary.question.option.infoText.importedData'),
                },
                // {
                //     compName: 'quadrant',
                //     icon: 'fa-light fa-chart-scatter',
                //     label: i18n.t('questionLibrary.question.option.addToQuadrant'),
                //     menuShow: this.checkVisibility('quadrant', question),
                //     menuType: 'checkbox',
                //     value: question.allowQuadrantAnalysis,
                //     onClick: () => this.executeAction(question.toggleAllowQuadrantAnalysis),
                //     menuTooltip: i18n.t('questionLibrary.question.option.infoText.addToQuadrant'),
                // },
                {
                    compName: 'inherit',
                    icon: 'fa-light fa-diagram-project',
                    label: i18n.t('questionLibrary.question.option.inherit'),
                    menuShow: this.checkVisibility('inherit'),
                    menuType: 'menu',
                    disabled: true,
                    menuTooltip: i18n.t('questionLibrary.question.option.infoText.inherit.enabled_desc'),
                    list: [
                        <div style={{ display: 'flex', flexDirection: 'column', gap: '15px' }}>
                            <div className="inherit-question-title">
                                <p>
                                    {i18n.t('questionLibrary.question.option.subMenuTitle.inherit')}
                                </p>
                            </div>
                            <Select
                                placeholder={i18n.t('questionLibrary.question.option.inheritPlaceholder')}
                                name="parentQuestion"
                                label={i18n.t('questionLibrary.question.option.inheritLabel')}
                                onBlur={this.changeParentId}
                                value={getParentOption(question.parentId)}
                                options={getPossibleParentQuestions(question)}
                            />
                        </div>,
                        <div>
                            <div
                                className="option-line"
                                style={{ display: !hasParentOption ? 'none' : undefined }}
                                onClick={() => {
                                    this.changeParentId({ value: null })
                                }}
                            >
                                <i className="fa-light fa-circle-xmark" />
                                <p dangerouslySetInnerHTML={{ __html: i18n.t('remove') }} />
                            </div>
                        </div>,
                    ],
                    iconShow: true,
                },
                {
                    compName: 'delete',
                    label: i18n.t('delete'),
                    icon: 'fa-light fa-circle-xmark',
                    greyBg: !hasChild,
                    menuShow: true,
                    disabled: hasChild,
                    menuTooltip: this.getDeleteToolTip(),
                    onClick: () => this.executeAction(this.setShowDeleteModal),
                },
            ]
        )
        return optionMenuList
    }

    getContextMenu = () => {
        const contextMenuOptions = this.createCtxMenu().filter((config) => (config.menuShow))
        return (
            contextMenuOptions.map((config) => {
                switch (config.menuType) {
                    case 'checkbox':
                        return (
                            <div className="option-line">
                                <i className={config.icon} />
                                <Checkbox
                                    name={config.label}
                                    label={config.label}
                                    labelDir="left"
                                    cssClass="option-check"
                                    tooltipText={config.menuTooltip}
                                    tooltipDir="left"
                                    checked={config.value}
                                    onBlur={config.onClick}
                                />
                            </div>
                        )
                    case 'menu':
                        return (
                            <Menu
                                cssClass="sub-menu"
                                list={config.list}
                                width="400px"
                                dir="left"
                                showTick
                                hasUniqueLast
                            >
                                <div className="option-line">
                                    <i className={config.icon} />
                                    <p dangerouslySetInnerHTML={{ __html: i18n.t(config.label) }} />
                                    {config.menuTooltip
                                        && (
                                            <HoverInfo
                                                cssClass="hover-info"
                                                desc={config.menuTooltip}
                                                title={config.label}
                                                dir="left"
                                            >
                                                <i className="info-icon fa-solid fa-circle-question" />
                                            </HoverInfo>
                                        )}
                                </div>
                            </Menu>
                        )
                    default:
                        return (
                            <div className={`option-line ${config.disabled ? 'menu-option-disabled' : ''}`} onClick={!config.disabled ? config.onClick : null}>
                                <i className={config.icon} />
                                <p dangerouslySetInnerHTML={{ __html: i18n.t(config.label) }} />
                                {config.menuTooltip
                                    && (
                                        <HoverInfo
                                            cssClass="hover-info"
                                            desc={config.menuTooltip}
                                            title={config.label}
                                            dir="left"
                                        >
                                            <i className="info-icon fa-solid fa-circle-question" />
                                        </HoverInfo>
                                    )}
                            </div>
                        )
                }
            })
        )
    }

    handleQuestionDelete = async (question) => {
        question.delete?.()
        const { store } = this.props
        const { questionType, filterQuestionLibraryList } = store
        filterQuestionLibraryList(questionType.value, true) // refresh list
    }

    renderQuestionItemFull = () => {
        const {
            question,
            provided,
            appStore,
        } = this.props
        const { isExpanded, isCtxMenuShown } = this.state
        const ctxMenuList = this.getContextMenu()

        const questionLevel = question.oid
        const showEditButton = question.isEditable && question.modifiable && question.deletable
        const titleClass = R.pathOr(true, ['modifiable'], question) ? '' : 'notModifiable'
        return (
            <div
                className="question-list-item"
                ref={provided.innerRef}
                {...provided.draggableProps}
                {...provided.dragHandleProps}
            >
                <div className="question-list-item-left-container">
                    <div className={`question-list-item-left q_${questionLevel}`} />
                    <div className="grab-container">
                        <img src={GrabIcon} alt="Grab icon" />
                    </div>
                </div>
                <div className="question-list-item-header">
                    <div className="question-list-item-right">
                        <div className="question-list-item-right-top">
                            <div className="options-icon-container">
                                {this.renderLeftIcons()}
                            </div>
                            <div className="title-inner-container" onClick={this.toggleIsExpanded}>
                                <Typography type="h4" cssClass={titleClass}>
                                    {this.getTitleByLocale(question)}
                                </Typography>
                            </div>
                            <div className="options-icon-container">
                                {this.renderRightIcons()}
                            </div>
                            {showEditButton
                                && (
                                    <Button
                                        label={i18n.t('edit')}
                                        cssClass="question-edit-btn"
                                        onClick={question.toggleEditable}
                                    />
                                )}
                            {question.modifiable && ctxMenuList.length > 0 && (
                                <div className={`options-container options-handler-container ${isCtxMenuShown ? 'focused' : ''}`} onClick={this.toggleCtxMenu}>
                                    <Menu
                                        cssClass="option-menu"
                                        list={ctxMenuList}
                                        minWidth="375px"
                                        dir="left"
                                        hasUniqueLast
                                    >
                                        <div className="menu-icon">
                                            <i className="fa-regular fa-ellipsis-vertical" />
                                        </div>
                                    </Menu>
                                </div>
                            )}

                        </div>
                        <div className={`question-list-item-content ${isExpanded ? 'content-padding' : ''}`}>
                            <AnimateHeight
                                duration={250}
                                height={isExpanded ? 'auto' : 0}
                            >
                                {isExpanded
                                    && (
                                        <div className="question-content-preview">
                                            <QuestionPreview
                                                store={appStore}
                                                question={this.questionFull}
                                            />
                                        </div>
                                    )}
                            </AnimateHeight>
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    renderQuestionItemLite = () => {
        const {
            question,
            provided,
            appStore,
        } = this.props
        const { isExpanded } = this.state

        const questionLevel = question.getQuestionLevel?.() ?? R.pathOr('1', ['questionoid'], question)
        const className = R.pathOr(true, ['modifiable'], question) ? '' : 'locked'
        const questionTitle = this.getTitleByLocale(question)
        return (
            <div
                className="question-list-item-minimal"
                ref={provided.innerRef}
                {...provided.draggableProps}
                {...provided.dragHandleProps}
            >
                <div className="question-list-item-header-minimal">
                    <div className={`question-list-item-left-minimal q_${questionLevel}`} />
                    <div title={questionTitle} className="question-list-item-right-minimal">
                        <img src={GrabIcon} alt="Grab icon" />
                        <div
                            className={`chevron-container ${isExpanded ? 'expanded' : ''}`}
                            onClick={this.toggleIsExpanded}
                        >
                            <i className={`fa ${isExpanded ? 'fa-chevron-up' : 'fa-chevron-down'}`} aria-hidden="true" />
                        </div>
                        <span className={className}>{questionTitle}</span>
                    </div>
                </div>
                <div className={`question-list-item-content-minimal ${isExpanded ? 'content-padding' : ''}`}>
                    <AnimateHeight
                        duration={250}
                        height={isExpanded ? 'auto' : 0}
                    >
                        {isExpanded
                            && (
                                <div className="question-content-preview">
                                    <QuestionPreview
                                        store={appStore}
                                        question={this.questionFull}
                                        isLite
                                    />
                                </div>
                            )}
                    </AnimateHeight>
                </div>
            </div>
        )
    }

    render() {
        const { isFullSize, question } = this.props
        const { showDeleteModal } = this.state
        const { closeDeleteModal } = this

        return (
            <div id="question-item">
                {isFullSize ? this.renderQuestionItemFull() : this.renderQuestionItemLite()}
                <DeleteQuestion
                    show={showDeleteModal}
                    onClose={closeDeleteModal}
                    onSelect={this.handleQuestionDelete}
                    question={question}
                />
            </div>
        )
    }
}
